const getHandledValue = num => {
    return num < 10 ? '0' + num : num
}

/*时间*/
export const getDate = (timeStamp, startType) => {
    const d = timeStamp || new Date(timeStamp * 1000)
    const year = d.getFullYear()
    const month = getHandledValue(d.getMonth() + 1)
    const date = getHandledValue(d.getDate())
    const hours = getHandledValue(d.getHours())
    const minutes = getHandledValue(d.getMinutes())
    const second = getHandledValue(d.getSeconds())
    let resStr = ''
    if (startType === 'year') resStr = month + '-' + date + ' ' + hours + ':' + minutes
    else if (startType === 'string') resStr = year + '年' + month + '月' + date + '日 ' + hours + '时' + minutes + '分' + second + '秒'
    else if (startType === 'lately') resStr = year + '-' + month + '-' + (date - 3) + ' ' + hours + ':' + minutes + ':' + second
    else if (startType === 'date') resStr = year + '-' + month + '-' + date
    else resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second
    return resStr
}

export const expirationtime = (time, type) => {
    let normalizeDate = time.split("-");
    let Month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();
    let date = new Date().getDate();
    let boole = true

    if (type == "end") {
        if (normalizeDate[0] < year) {
            boole = false
        } else if (normalizeDate[0] == year && normalizeDate[1] < Month) {
            boole = false
        } else if (normalizeDate[0] == year && normalizeDate[1] == Month && normalizeDate[2] < date) {
            boole = false
        }
    } else if (type == "beg") {
        if (normalizeDate[0] > year) {
            boole = false
        } else if (normalizeDate[0] == year && normalizeDate[1] > Month) {
            boole = false
        } else if (normalizeDate[0] == year && normalizeDate[1] == Month && normalizeDate[2] > date) {
            boole = false
        }
    }
    console.log(boole)
    return boole
}